/* Dim Nook — Nightreader v3
   RoverOak-audit lessons baked in:
   - capture-phase double-submit guard w/ in-flight lock + failsafe release
   - sticky ATC only after the gallery is scrolled PAST (top<0 — never
     during the PDP scroll demo above it)
   - accessible variant picker (real buttons, aria-checked)
   - no price-derived thresholds, no fabricated delivery dates
   v3: swipeable scroll-snap gallery w/ dots (mobile) + thumb/plate (desktop) */
(function () {
  'use strict';

  /* ---------- announcement rotator ---------- */
  var bar = document.getElementById('dn-rotbar');
  if (bar) {
    var msgs = bar.querySelectorAll('span');
    if (msgs.length > 1) {
      var mi = 0;
      setInterval(function () {
        msgs[mi].classList.remove('on');
        mi = (mi + 1) % msgs.length;
        msgs[mi].classList.add('on');
      }, 3600);
    }
  }

  var form = document.getElementById('dn-product-form');
  if (!form) return;

  /* ---------- gallery: slider (mobile) + thumbs (desktop) ---------- */
  var slider = document.getElementById('dn-slider');
  var slides = slider ? Array.prototype.slice.call(slider.querySelectorAll('.dn-slide')) : [];
  var dotsWrap = document.getElementById('dn-dots');
  var dots = [];

  function setActiveSlide(i, scrollIt) {
    slides.forEach(function (s, j) { s.classList.toggle('active', j === i); });
    dots.forEach(function (d, j) { d.classList.toggle('active', j === i); });
    document.querySelectorAll('[data-dn-thumb]').forEach(function (b, j) { b.classList.toggle('active', j === i); });
    if (scrollIt && slider) {
      var s = slides[i];
      if (s) slider.scrollTo({ left: s.offsetLeft - slider.offsetLeft, behavior: 'smooth' });
    }
  }

  if (dotsWrap && slides.length > 1) {
    slides.forEach(function (_, i) {
      var b = document.createElement('button');
      b.type = 'button';
      if (i === 0) b.classList.add('active');
      b.addEventListener('click', function () { setActiveSlide(i, true); });
      dotsWrap.appendChild(b);
      dots.push(b);
    });
    var st;
    slider.addEventListener('scroll', function () {
      clearTimeout(st);
      st = setTimeout(function () {
        var w = slides[0] ? slides[0].offsetWidth + 10 : 1;
        var i = Math.round(slider.scrollLeft / w);
        i = Math.max(0, Math.min(slides.length - 1, i));
        dots.forEach(function (d, j) { d.classList.toggle('active', j === i); });
      }, 80);
    }, { passive: true });
  }

  document.querySelectorAll('[data-dn-thumb]').forEach(function (btn, i) {
    btn.addEventListener('click', function () { setActiveSlide(i, true); });
  });

  function showMediaId(mediaId) {
    var idx = slides.findIndex(function (s) { return s.dataset.mediaId === String(mediaId); });
    if (idx >= 0) setActiveSlide(idx, true);
  }

  /* ---------- variant selection ---------- */
  var variantsEl = document.querySelector('[data-dn-variants]');
  var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
  var idInput = form.querySelector('[data-dn-variant-id]');

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function currentSelection() {
    var sel = {};
    document.querySelectorAll('.dn-styleopt.active').forEach(function (b) {
      sel[b.dataset.optionIndex] = b.dataset.value;
    });
    return sel;
  }

  function applyVariant(v) {
    if (!v) return;
    if (idInput) idInput.value = v.id;
    var p = document.querySelector('[data-dn-price]');
    var c = document.querySelector('[data-dn-compare]');
    var s = document.querySelector('[data-dn-save]');
    if (p) p.textContent = money(v.price);
    if (c) c.textContent = v.compare_at_price ? money(v.compare_at_price) : '';
    if (s && v.compare_at_price && v.compare_at_price > v.price) {
      s.textContent = 'Save ' + money(v.compare_at_price - v.price).replace('.00', '');
      s.style.display = '';
    } else if (s) { s.style.display = 'none'; }
    basePrice = v.price;
    var label = document.querySelector('[data-dn-atc-label]');
    if (label) label.textContent = v.available ? 'Add to Cart — ' + money(v.price) : 'Sold out';
    var atc = document.getElementById('dn-atc');
    if (atc) atc.disabled = !v.available;
    var sp = document.querySelector('[data-dn-sticky-price]');
    if (sp) sp.textContent = money(v.price);
    /* swap gallery to the variant's own photo when it has one */
    if (v.featured_media && v.featured_media.id) showMediaId(v.featured_media.id);
    else if (v.featured_image && v.featured_image.id) showMediaId(v.featured_image.id);
    if (typeof refreshAtc === 'function') refreshAtc();
  }

  document.querySelectorAll('[data-dn-option]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = btn.closest('.dn-styles');
      group.querySelectorAll('[data-dn-option]').forEach(function (b) {
        b.classList.remove('active');
        b.setAttribute('aria-checked', 'false');
      });
      btn.classList.add('active');
      btn.setAttribute('aria-checked', 'true');
      var nameEl = group.previousElementSibling.querySelector('[data-dn-optname]');
      if (nameEl) nameEl.textContent = btn.dataset.value;
      selectPack('single'); /* choosing a style returns to the single item */
      var sel = currentSelection();
      var match = variants.find(function (v) {
        return Object.keys(sel).every(function (idx) {
          return v['option' + idx] === sel[idx];
        });
      });
      applyVariant(match);
    });
  });

  /* ---------- in-page bundle pack selection ----------
     Clicking a bundle card swaps price + ATC to that bundle's variant right
     here on the page (no navigation). The active card reveals a combo
     dropdown when the bundle has multiple variants. */
  var packs = Array.prototype.slice.call(document.querySelectorAll('[data-dn-pack]'));
  var activePack = 'single';

  function money0(cents) { return money(cents).replace('.00', ''); }

  function setBuyState(variantId, priceCents, compareCents, available) {
    if (idInput) idInput.value = variantId;
    basePrice = priceCents;
    var p = document.querySelector('[data-dn-price]');
    var c = document.querySelector('[data-dn-compare]');
    var s = document.querySelector('[data-dn-save]');
    if (p) p.textContent = money(priceCents);
    if (c) c.textContent = compareCents > priceCents ? money(compareCents) : '';
    if (s) {
      if (compareCents > priceCents) { s.textContent = 'Save ' + money0(compareCents - priceCents); s.style.display = ''; }
      else s.style.display = 'none';
    }
    var label = document.querySelector('[data-dn-atc-label]');
    if (label) label.textContent = available ? 'Add to Cart — ' + money(priceCents) : 'Sold out';
    if (atcBtn) atcBtn.disabled = !available || isAdding;
    var sp = document.querySelector('[data-dn-sticky-price]');
    if (sp) sp.textContent = money(priceCents);
    if (typeof refreshAtc === 'function') refreshAtc();
  }

  function applySingleSelection() {
    var sel = currentSelection();
    var match = variants.find(function (v) {
      return Object.keys(sel).every(function (idx) { return v['option' + idx] === sel[idx]; });
    }) || variants[0];
    if (match) setBuyState(match.id, match.price, match.compare_at_price || 0, match.available);
  }

  function applyPackSelection(card) {
    var combo = card.querySelector('[data-pack-combo]');
    if (combo) {
      var opt = combo.options[combo.selectedIndex];
      var priceEl = card.querySelector('[data-pack-price]');
      var compEl = card.querySelector('[data-pack-compare]');
      var price = parseInt(opt.dataset.price, 10);
      var comp = parseInt(opt.dataset.compare || '0', 10);
      if (priceEl) priceEl.textContent = money(price);
      if (compEl) compEl.textContent = comp > price ? money(comp) : '';
      setBuyState(opt.value, price, comp, true);
    } else {
      var priceTxt = card.querySelector('[data-pack-price]');
      var cents = priceTxt ? Math.round(parseFloat(priceTxt.textContent.replace(/[^0-9.]/g, '')) * 100) : 0;
      var compTxt = card.querySelector('[data-pack-compare]');
      var compCents = compTxt ? Math.round(parseFloat(compTxt.textContent.replace(/[^0-9.]/g, '')) * 100) : 0;
      setBuyState(card.dataset.variantId, cents, compCents, true);
    }
  }

  function selectPack(id) {
    activePack = id;
    packs.forEach(function (card) {
      var on = card.dataset.dnPack === id;
      card.classList.toggle('active', on);
      card.setAttribute('aria-pressed', String(on));
    });
  }

  /* ---------- optional add-on (Shelf Resident) ---------- */
  var addonSel = document.querySelector('[data-dn-addon]');
  var basePrice = variants.length ? (variants.find(function (v) { return String(v.id) === idInput.value; }) || variants[0]).price : 0;
  function addonPrice() {
    if (!addonSel || !addonSel.value) return 0;
    return parseInt(addonSel.options[addonSel.selectedIndex].dataset.price, 10) || 0; /* Liquid v.price is already cents */
  }
  function refreshAtc() {
    var total = basePrice + addonPrice();
    var label = document.querySelector('[data-dn-atc-label]');
    if (label && atcBtn && !atcBtn.disabled) label.textContent = 'Add to Cart — ' + money(total);
    var sp = document.querySelector('[data-dn-sticky-price]');
    if (sp) sp.textContent = money(total);
  }
  if (addonSel) addonSel.addEventListener('change', refreshAtc);

  packs.forEach(function (card) {
    function activate() {
      selectPack(card.dataset.dnPack);
      if (card.dataset.dnPack === 'single') applySingleSelection();
      else applyPackSelection(card);
    }
    card.addEventListener('click', activate);
    card.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activate(); }
    });
    var combo = card.querySelector('[data-pack-combo]');
    if (combo) {
      combo.addEventListener('click', function (e) { e.stopPropagation(); });
      combo.addEventListener('change', function () {
        selectPack(card.dataset.dnPack);
        applyPackSelection(card);
      });
    }
  });

  /* ---------- add-to-cart: single-flight guard ---------- */
  var isAdding = false;
  var atcBtn = document.getElementById('dn-atc');
  var stickyBtn = document.getElementById('dn-sticky-btn');

  function setAdding(state) {
    isAdding = state;
    [atcBtn, stickyBtn].forEach(function (b) {
      if (!b) return;
      b.disabled = state;
      if (b === stickyBtn) b.textContent = state ? 'Adding…' : 'Add to Cart';
    });
    var label = document.querySelector('[data-dn-atc-label]');
    if (label && state) label.textContent = 'Adding…';
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (isAdding) return;            /* capture the double-tap */
    setAdding(true);
    var failsafe = setTimeout(function () { setAdding(false); }, 4000);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: (function () {
        var items = [{ id: parseInt(idInput.value, 10), quantity: 1 }];
        if (addonSel && addonSel.value) items.push({ id: parseInt(addonSel.value, 10), quantity: 1 });
        return items;
      })() })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        var count = document.querySelector('[data-dn-cart-count]');
        if (count) count.textContent = cart.item_count;
        clearTimeout(failsafe);
        setAdding(false);
        window.location.href = '/cart';
      })
      .catch(function () {
        clearTimeout(failsafe);
        setAdding(false);
      });
  }, true); /* capture phase */

  if (stickyBtn) {
    stickyBtn.addEventListener('click', function () {
      if (isAdding) return;
      form.requestSubmit();
    });
  }

  /* ---------- sticky bar: only once the gallery is scrolled PAST ---------- */
  var sticky = document.getElementById('dn-sticky');
  var gallery = document.getElementById('dn-gallery');
  if (sticky && gallery && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var out = !e.isIntersecting && e.boundingClientRect.top < 0;
      sticky.classList.toggle('show', out);
      sticky.setAttribute('aria-hidden', String(!out));
    }, { threshold: 0 }).observe(gallery);
  }
})();
